import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useState, useCallback, useRef } from 'react';
export var useModalPromise = function useModalPromise() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setOpened = _useState2[1];

  var promise = useRef({});
  var show = useCallback(function _callee() {
    return _regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setOpened(true);
            _context.prev = 1;
            _context.next = 4;
            return _regeneratorRuntime.awrap(new _Promise(function (resolve, reject) {
              _Object$assign(promise.current, {
                resolve: resolve,
                reject: reject
              });
            }));

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
            _context.prev = 5;
            setOpened(false);
            return _context.finish(5);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[1,, 5, 8]], Promise);
  }, []);
  var resolve = useCallback(function (result) {
    return promise.current.resolve(result);
  }, [promise]);
  var reject = useCallback(function (error) {
    return promise.current.reject(error);
  }, [promise]);
  return [isOpened, show, resolve, reject];
};